export const es = {
  // Header
  header: {
    title: "Hazte global. $2 por Short. ¡En cualquier idioma!",
    subtitle: "🔥Paga solo por resultados – desde $0.089 hasta $0.009 por segundo🔥"
  },

  // Steps
  steps: {
    uploadVideo: "Subir Video",
    selectLanguages: "Seleccionar Idiomas", 
    conversionResult: "Conversión y Resultado"
  },

  // Upload section
  upload: {
    dragAndDrop: "Arrastra y suelta tu archivo de video aquí",
    orClickToSelect: "o haz clic para seleccionar",
    supportedFormats: "Formatos soportados: MP4, AVI, MOV, MKV, WebM",
    maxFileSize: "• Tamaño máximo de archivo: 200 MB",
    maxDuration: "• Duración máxima: 30 seg",
    processingTime: "• El procesamiento tomará de 2 a 15 minutos dependiendo de la resolución del video",
    chooseFile: "Elegir Archivo",
    selectedFile: "Archivo seleccionado:",
    size: "Tamaño:",
    fileTypeError: "Por favor selecciona un archivo de video",
    fileSizeError: "El tamaño del archivo ({size} MB) supera el límite máximo de 200 MB",
    durationError: "La duración del video ({duration} seg) supera el límite máximo de 30 seg",
    fileReadError: "No se puede leer el archivo de video. Por favor intenta con un archivo diferente."
  },

  // Language selection
  languages: {
    sourceAudioLanguage: "Idioma de audio origen",
    targetAudioLanguage: "Idioma de audio destino",
    selectLanguage: "Seleccionar idioma..."
  },

  // Language options
  languageOptions: {
    ru: "Ruso",
    en: "Inglés",
    es: "Español",
    fr: "Francés",
    de: "Alemán",
    it: "Italiano",
    pt: "Portugués",
    pl: "Polaco",
    zh: "Chino",
    ja: "Japonés",
    ko: "Coreano",
    bg: "Búlgaro",
    hr: "Croata",
    cs: "Checo",
    da: "Danés",
    nl: "Neerlandés",
    et: "Estonio",
    fi: "Finlandés",
    el: "Griego",
    hu: "Húngaro",
    ga: "Irlandés",
    lv: "Letón",
    lt: "Lituano",
    mt: "Maltés",
    ro: "Rumano",
    sk: "Eslovaco",
    sl: "Esloveno",
    sv: "Sueco"
  },

  // Conversion
  conversion: {
    replaceAudio: "Clonar mi voz",
    uploadVideoAndSelectLanguages: "Sube un video y selecciona idiomas para continuar",
    fixValidationError: "Por favor corrige el error de validación del archivo arriba",
    createSubtitles: "Crear Subtítulos",
    uploadVideoForSubtitles: "Sube un video para crear subtítulos",
    selectTranslationLanguage: "Selecciona el idioma de traducción"
  },

  // Demo video section
  demo: {
    seeVeviInAction: "Ver VEVI en Acción",
    watchHowItWorks: "Mira cómo funciona nuestra tecnología de reemplazo de voz con IA",
    beforeEnglish: "Antes (Inglés)",
    originalPresentation: "Presentación corporativa original",
    afterSpanish: "Después (Español,Francés, Chino, Italiano)",
    aiTranslatedVoice: "Traducido por IA con voz natural",
    demoTitle: "Demo - VEVI en Acción"
  },

  // Reviews
  reviews: {
    title: "Lo Que Dicen Nuestros Clientes",
    subtitle: "Confiado por profesionales de marketing en todo el mundo",
    customerReviews: [
      {
        name: "Sarah Johnson",
        position: "Gerente de Marketing Digital",
        company: "TechFlow Solutions",
        text: "¡VEVI transformó nuestras campañas de marketing internacional! Localizamos nuestros videos de demostración de productos para 8 mercados diferentes en solo un día. La calidad es increíble y los precios son tan transparentes."
      },
      {
        name: "Michael Chen",
        position: "Director de Marketing de Contenido", 
        company: "GlobalReach Media",
        text: "Como alguien que gestiona contenido de video para múltiples regiones, VEVI es un cambio de juego. El reemplazo de voz es tan natural que nuestras audiencias no pueden distinguir que está generado por IA. ¡Altamente recomendado!"
      },
      {
        name: "Emma Rodriguez",
        position: "Especialista en Marketing de Marca",
        company: "InnovateCorp",
        text: "Ahorramos miles en costos de locución mientras nos expandíamos a nuevos mercados. El precio de $0.0314 por segundo es increíblemente justo, y los resultados hablan por sí mismos. ¡Nuestras tasas de conversión aumentaron un 40%!"
      },
      {
        name: "David Thompson",
        position: "Gerente de Campañas de Marketing",
        company: "NextGen Brands",
        text: "La velocidad y calidad de VEVI no tiene igual. Pasamos de tener un video en inglés a 12 versiones localizadas en diferentes idiomas en horas. Esta herramienta es esencial para el marketing global."
      },
      {
        name: "Lisa Park",
        position: "Líder de Marketing en Redes Sociales",
        company: "CreativeEdge Agency",
        text: "VEVI hizo posible que nuestra pequeña agencia ofrezca servicios de video multilingües a clientes. La calidad es de nivel profesional y el proceso es increíblemente simple. ¡Nuestros clientes aman los resultados!"
      },
      {
        name: "James Wilson",
        position: "Director de Marketing de Rendimiento",
        company: "ScaleUp Ventures",
        text: "El ROI lo es todo en marketing de rendimiento, y VEVI cumple. Redujimos nuestros costos de localización de video en un 80% mientras mejoramos el tiempo de entrega de semanas a horas. Esta herramienta se paga inmediatamente."
      }
    ]
  },

  // Payment dialog
  payment: {
    title: "Pago de Conversión",
    processingCost: "Costo de Procesamiento",
    duration: "Duración:",
    baseCost: "Costo base",
    discount: "Descuento ({promoCode}):",
    discountAmount: "Monto del descuento:",
    total: "Total:",
    emailToReceiveResult: "Email para recibir el resultado",
    emailPlaceholder: "tu-email@ejemplo.com",
    promoCode: "🎟️ Código Promocional (opcional)",
    promoCodePlaceholder: "Ingresa código promocional",
    check: "Verificar",
    checking: "Verificando...",
    addSubtitles: "Agregar subtítulos al video",
    addSubtitlesDescription: "Generar e incrustar subtítulos en el idioma objetivo",
    highQualityTranslation: "• Traducción de IA de alta calidad",
    originalVideoPreserved: "• Video original preservado",
    fastProcessing: "• Procesamiento rápido (típicamente 5-10 minutos)",
    resultWillBeSent: "• El resultado será enviado al email especificado",
    cancel: "Cancelar",
    continue: "Continuar",
    enterEmail: "Por favor ingresa tu email",
    enterValidEmail: "Por favor ingresa una dirección de email válida",
    enterPromoCode: "Por favor ingresa un código promocional",
    invalidPromoCode: "Código promocional inválido",
    validPromoCode: "¡Código promocional válido! Descuento del {discount}% aplicado"
  },

  // Progress dialog
  progress: {
    title: "Procesando Video",
    uploadingAndExtracting: "🎬 Subiendo y extrayendo audio",
    transcribingAndTranslating: "🗣️ Transcribiendo discurso y traduciendo", 
    synthesizingAudio: "🎵 Sintetizando nueva pista de audio",
    step: "Paso:",
    error: "Error"
  },

  // Result dialog
  result: {
    title: "¡Completo! Tu video ha sido procesado",
    conversionCompleted: "¡Conversión completada exitosamente!",
    processedVideoDescription: "🎬 Tu video procesado con clonación de voz",
    payAndDownload: "Pagar y Descargar",
    videoNotAvailable: "Video no disponible",
    useDownloadButton: "Por favor usa el botón de descarga abajo",
    downloadError: "Error de Descarga"
  },

  // Email sent dialog
  emailSent: {
    title: "¡Video Enviado! 🎉",
    videoOnWay: "El video ya está en camino a tu email 🙏❤️",
    checkInbox: "Revisa tu bandeja de entrada y carpeta de spam. ¡El video procesado llegará pronto!",
    whatsNext: "¿Qué sigue?",
    checkEmail: "• Revisa tu email ({email})",
    checkSpam: "• Busca en la carpeta de spam/correo no deseado si no lo encuentras",
    downloadAndEnjoy: "• ¡Descarga y disfruta tu video doblado!",
    close: "Cerrar",
    processAnotherVideo: "Procesar Otro Video"
  },

  // Processing steps
  processingSteps: {
    uploading: "Subiendo video...",
    extracting: "Extrayendo audio...",
    transcribing: "Transcribiendo discurso...",
    translating: "Traduciendo contenido...",
    synthesizing: "Sintetizando nueva voz...",
    rendering: "Renderizando video final...",
    complete: "¡Procesamiento completo!"
  },

  // Common
  common: {
    minutes: "minutos",
    seconds: "segundos",
    loading: "Cargando...",
    error: "Error",
    success: "Éxito"
  },

  // Social media
  socialMedia: {
    title: "Conecta con nosotros",
    description: "Obtén las últimas actualizaciones sobre la tecnología de voz con IA"
  },

  // Services (for Footer)
  services: {
    dubbing: "Doblaje",
    voiceClone: "Doblaje con clonación de voz",
    newVoice: "Doblaje con nueva voz",
    multilingual: "Doblaje multilingüe",
    multiSpeaker: "Doblaje multi-hablante",
    subtitles: "Subtítulos",
    subtitlesOnly: "Solo subtítulos",
    multilingualSubtitles: "Subtítulos multilingües",
    subtitlesDescription: "Genere automáticamente subtítulos precisos para cualquier plataforma.",
    subtitlesPrice: "Costo de procesamiento: $0.01/seg",
    addSubtitles: "Agregar subtítulos",
    needsTranslation: "¿Necesita traducción?",
    translationLanguage: "Idioma de traducción"
  },

  // Footer
  footer: {
    legal: "Legal",
    privacyPolicy: "Política de privacidad",
    termsOfUse: "Términos de uso"
  },

  // Navigation
  nav: {
    blog: "Blog"
  },

  // Blog
  blog: {
    title: "Blog VEVI Monster",
    subtitle: "Historia y mitología del universo VEVI",
    readMore: "Leer más",
    backToBlog: "Volver al blog",
    articleNotFound: "Artículo no encontrado",
    characteristics: "Características",
    articles: {
      "vevi-monster": {
        title: "VEVI Monster",
        excerpt: "Vevi es un ser nacido de los vórtices de plasma de Zera-13b. No es de carne ni de metal—su cuerpo consiste en partículas vibrantes mantenidas juntas por un campo electromagnético.",
        metadata: {
          "Galaxia": "MoM-z14",
          "Edad": "13,4 mil millones de años",
          "Tipo": "Planeta rocoso con una atmósfera densa de metano y neón",
          "Estrella": "Protostrella roja Zera-13",
          "Órbita": "Segundo planeta del sistema",
        },
        content: [
          "🌑 Descripción",
          "Zera-13b es un mundo antiguo y casi olvidado, nacido en una era cuando el Universo apenas aprendía a brillar.",
          "Su cielo brilla con llamas verdes tenues, y la atmósfera densa tiembla por las tormentas de neón. La superficie es un paisaje negro-gris cubierto de cráteres vidriosos donde los vientos de metano dejan rastros de fuego en el aire.",
          "Bajo la superficie yacen cuevas de gas congelado, donde, según las leyendas, nacieron las primeras formas de energía capaces de pensar.",
          "👾 Vevi (Vevi Monster)",
          "Vevi es un ser nacido de los vórtices de plasma de Zera-13b.",
          "No es de carne ni de metal—su cuerpo consiste en partículas vibrantes mantenidas juntas por un campo electromagnético.",
          "Sus ojos brillan con la luz reflejada de la estrella Zera-13, y su voz suena como el susurro del viento de neón.",
          "Vevi dejó su mundo cuando la protostrella comenzó a desvanecerse. Viajó a través de vacíos intergalácticos, guiado por el instinto de buscar nueva energía.",
          "Ahora vaga por mundos, llevando consigo una partícula de la luz primordial de Zera-13b.",
          "El resplandor le vino del planeta",
          "No tiene piernas—porque el planeta tiene una gravedad enorme y simplemente levita",
          "Se comunica (o más bien emite sonidos) similares a las ondas acústicas de delfines, ballenas y orcas.",
          "Su idioma se llama UFOnic",
        ],
      },
      "baddy-sub": {
        title: "Baddy Sub",
        excerpt: "Baddy Sub es un ser del Universo temprano, nacido en Sub Zone, una región rara del espacio con alta densidad de materia.",
        metadata: {
          "Nombre del objeto": "Sub Zone (SUB-Z)",
          "Tipo de objeto": "Protocúmulo / región de formación de galaxias",
          "Época": "~200–300 millones de años después del Big Bang",
          "Corrimiento al rojo": "z ≈ 14–15",
          "Ascensión recta (RA)": "02h 17m 43s",
          "Declinación (Dec)": "−04° 12′ 09″",
        },
        content: [
          "Datos de Baddy Sub",
          "Cuerpo largo, delgado y oblongo con dos extremidades inferiores en la parte inferior y tres ojos en formas extendidas en la parte superior",
          "No tiene boca.",
          "También hay dos extremidades superiores delgadas que pueden interpretarse como brazos.",
          "Dos dedos en cada extremidad.",
          "Todo el cuerpo se parece a una rama de árbol",
          "La piel tiene una estructura mate suave",
          "El color es verde-marrón (pigmentación)",
          "Puede cambiar de color según el entorno como un camaleón.",
          "Descripción del planeta donde nació Baddy Sub:",
          "Sub Zone es una región rara del Universo temprano con alta densidad de materia, donde comenzaron a formarse las primeras estructuras galácticas. Las observaciones indican interacciones intensas de gas primordial, radiación y ondas gravitacionales. La región ha registrado patrones de señal inestables y actividad resonante anómala, no característica de las regiones protogalácticas típicas.",
          "Significancia científica:",
          "Sub Zone se considera un objeto clave para estudiar las primeras etapas del ensamblaje de galaxias, la propagación de señales en el Universo joven y la transición de campos de radiación caóticos a sistemas cósmicos estructurados.",
          "Estado:",
          "Clasificado como región de formación no resuelta. Se requiere más investigación.",
        ],
      },
    },
  },

  // FAQ
  faq: {
    title: "Preguntas Frecuentes",
    subtitle: "Todo lo que necesitas saber sobre VEVI",
    questions: [
      {
        question: "¿Solo trabajan con voz?",
        answer: "Sí — reemplazamos tu voz para que suene en otro idioma manteniendo naturalidad y autenticidad."
      },
      {
        question: "¿Pago antes o después?",
        answer: "Después. Primero escuchas el resultado, luego pagas."
      },
      {
        question: "¿Reembolsos?",
        answer: "No son necesarios — pagas solo cuando estés contento con el resultado."
      },
      {
        question: "¿Video más largo de 5 minutos?",
        answer: "Sin problema. Pregunta a nuestro asistente de IA en el chat en línea para instrucciones."
      },
      {
        question: "¿Puedo elegir otra voz?",
        answer: "No — solo clonamos tu propia voz."
      },
      {
        question: "¿Pago mínimo?",
        answer: "Desde $0.50."
      },
      {
        question: "¿Cómo obtengo mi video?",
        answer: "Descarga instantánea en tu navegador + copia a tu email después del pago."
      },
      {
        question: "¿Descuentos para pedidos grandes?",
        answer: "Sí — contacta a nuestro asistente de IA en el chat en línea."
      },
      {
        question: "¿No encontraste tu respuesta?",
        answer: "Pregunta a nuestro asistente de IA en el chat en línea — estamos aquí para ayudar."
      },
      {
        question: "¿Formato no compatible?",
        answer: "Usa un convertidor u obtén ayuda rápida de nuestro asistente de IA en el chat en línea."
      },
      {
        question: "Mi video incluye términos específicos que deben pronunciarse correctamente. ¿Puedo controlar eso?",
        answer: "Sí — solo envía un mensaje a nuestro asistente de IA en el chat en línea, y te enviaremos instrucciones sobre cómo marcar o preservar ciertos términos (por ejemplo, dejarlos en inglés)."
      },
      {
        question: "No recibí mi correo electrónico. ¿Qué debo hacer?",
        answer: "El tiempo de procesamiento puede variar debido al volumen de la cola. No te preocupes — tu archivo está seguro. Recibirás una notificación o un enlace de descarga directo una vez que esté listo."
      }
    ]
  }
};
